import { useCurrentUser } from "../lib/hooks/useCurrentUser";
import Title from "../components/ui/Title";
import { Skeleton } from "../components/ui/skeleton";
import MonSyndicat from "../components/syndicat/MonSyndicat";
import PasDeSyndicat from "../components/syndicat/PasDeSyndicat";

const SyndicatPage = () => {
  const { data: user } = useCurrentUser();

  return (
    <div className='mx-auto w-full max-w-7xl pb-8'>
      <div className='mb-7'>
        <Title>Mon syndicat</Title>
        <p className='mt-2 max-w-2xl text-sm leading-6 text-slate-600 md:text-base'>
          Retrouvez les coordonnées de votre syndicat
        </p>
      </div>

      {/* LOADING */}
      {!user && (
        <section className='overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_18px_55px_-35px_rgba(15,23,42,0.45)]'>
          <div className='border-b border-slate-100 bg-[#fbfaf6] px-5 py-5 sm:px-7 lg:px-8'>
            <Skeleton className='h-10 w-52' />
          </div>
          <div className='grid gap-6 p-5 sm:p-7 lg:grid-cols-[minmax(0,1fr)_19rem] lg:p-8'>
            <div className='space-y-5'>
              <Skeleton className='h-9 w-2/3' />
              <Skeleton className='h-16 w-full' />
              <Skeleton className='h-16 w-full' />
            </div>
            <Skeleton className='h-56 w-full rounded-2xl' />
          </div>
        </section>
      )}

      {/* Pas de syndicat */}
      {!!user && !user.syndicat && <PasDeSyndicat />}

      {/* Un syndicat */}
      {!!user && user.syndicat && <MonSyndicat syndicat={user.syndicat} />}
    </div>
  );
};

export default SyndicatPage;
